// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { Variants } from 'framer-motion';

export const burgerPathTopVariants: Variants = {
    closed: {
        d: 'M1 1L21 1',
    },
    open: {
        d: 'M1 1L21 21',
    },
};

export const burgerPathMiddleVariants: Variants = {
    closed: {
        d: 'M1 11L21 11',
    },
    open: {
        d: 'M11 11L11 11',
    },
};

export const burgerPathBottomVariants: Variants = {
    closed: {
        d: 'M1 21L21 21',
    },
    open: {
        d: 'M21 1L1 21',
    },
};
